<template>
  <modal
    class="confirmModal"
    :show="isConfirmOpen"
    :closeModal="closeModal"
  >
    <div slot="header">
    </div>
    <div
      slot="body"
      v-html="message"
    ></div>
    <div slot="footer">
      <button
        class="button52"
        @click.stop="handleClick(true)"
        ref="btn"
      >
        확인
      </button>
      <button
        class="button53"
        @click.stop="handleClick()"
      >
        취소
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/views/base/Modal'
import { mapState, mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  watch: {
    isConfirmOpen: function(val) {
      if (val) {
        this.buttonFocus()
      }
    }
  },
  components: {
    Modal
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('modal', ['isConfirmOpen', 'message', 'callback', 'closeCallback'])
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick(callCallback) {
      if (callCallback && typeof this.callback === 'function') {
        this.callback()
      } else if (typeof this.closeCallback === 'function') {
        this.closeCallback()
      }
      this.closeModal()
    }
  },
  mounted() {
    this.buttonFocus()
  }
}
</script>


